import { LocalizedText } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { ButtonProps, Dialog, DialogProps } from '@optimus-web/core';

interface Props {
    entityName?: string;
    opened?: boolean;
    deleting?: boolean;
    onCancel?: () => void;
    onConfirmation?: (() => void) | (() => Promise<void>);
}

const EntityDeleteDialog: React.FC<Props & Partial<DialogProps>> = ({
    entityName,
    opened,
    deleting,
    onConfirmation,
    onCancel,
    children,
    ...other
}) => {
    const actions: ButtonProps[] = [
        {
            children: <LocalizedText textKey={TextKey.GoBack} />,
            onClick: onCancel,
            variant: 'ghost',
            type: 'submit',
        },
        {
            children: <LocalizedText textKey={TextKey.Delete} />,
            onClick: onConfirmation,
            variant: 'destructive',
            type: 'submit',
        },
    ];

    return (
        <Dialog
            // @ts-expect-error $TSFixMeError: No overload matches this call.
            title={<LocalizedText textKey={TextKey.DeleteConfirmation} substitutes={{ entity: entityName }} />}
            actions={actions}
            active={opened}
            loading={deleting}
            onClose={onCancel}
            {...other}
        >
            {children || <LocalizedText textKey={TextKey.DeleteHint} />}
        </Dialog>
    );
};

export default EntityDeleteDialog;
